var mentions_default = {
  "mentionPalette": "_0xDNg",
  "mention": "Q8lkn",
  "mentionViewer": "vqWDy",
  "mentionSuggestionsEntry": "_2vDwg",
  "mentionSuggestionsEntryFocused": "MIye7",
  "mentionSuggestionsEntryText": "alEn4",
  "mentionSuggestionsEntryAvatar": "zazlE",
  "mentionSuggestions": "tRMHw",
  "cursorDefault": "xvKBB",
  "cursorPointer": "L6zyY"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
